  import './home.css'
  import { useState, useRef, useEffect } from "react";
  import { Link } from 'react-router-dom';
  import { Helmet } from 'react-helmet';

  export default function CarServiceHome() {
    const [openQuestion, setOpenQuestion] = useState(null);
    // const [btnText, setBtnText] = useState(texts[0]);

    const handleClick = (index) => {
      // Toggle the answer visibility for clicked question
      setOpenQuestion(openQuestion === index ? null : index); 
    };



  const heroContent = [
    {
      heading: "Reliable Car Service in Palwal",
      tagline: "Affordable, Fast & Trusted Car Service",
      desc: "Providing top-notch car maintenance and repair services to keep you on the road.",
      btn: "Get Started",
    },
    {
      heading: "Professional Car Service & Repair",
      tagline: "Quality Service You Can Rely On",
      desc: "Expert mechanics delivering reliable car repair and servicing at fair prices.",
      btn: "Contact Us",
    },
    {
      heading: "Quick & Reliable Car Care",
      tagline: "Your Car, Our Responsibility",
      desc: "From regular servicing to major repairs, we handle everything professionally.",
      btn: "Book Service",
    },
    {
      heading: "24/7 Car Support Available",
      tagline: "We Are Just One Call Away",
      desc: "Emergency breakdown support and scheduled servicing anytime you need.",
      btn: "Call Now",
    },
  ];




  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % heroContent.length);
    }, 3000);

    return () => clearInterval(interval);
  },);



    const botReplies = [
    {
      keywords: ["service", "services", "repair"],
      reply: "We provide car servicing, repairs, detailing, ceramic coating, engine, brake, AC and more."
    },
    {
      keywords: ["timing", "open", "hours"],
      reply: "We are open Monday to Sunday, 9 AM to 8 PM."
    },
    {
      keywords: ["price", "cost", "charges"],
      reply: "Prices depend on the service and car model. Please contact our team for exact pricing."
    },
    {
      keywords: ["booking", "appointment"],
      reply: "You can book a service directly from our website or contact our team."
    },
    {
      keywords: ["location", "address"],
      reply: "We are located at our main Auto Care service center. Please contact us for directions."
    }
  ];
    const [open1, setOpen1] = useState(false);
    const [messages, setMessages] = useState([
      { sender: "bot", text: "Hi 👋 How can I help you with your car today?" }
    ]);
    const [input, setInput] = useState("");

    const getBotReply = (msg) => {
      const lowerMsg = msg.toLowerCase();

      for (let item of botReplies) {
        if (item.keywords.some(word => lowerMsg.includes(word))) {
          return item.reply;
        }
      }

      return (
        "I'm sorry, I don't have information about that right now. " +
        "Please contact our team 📞 232324534 or 📧 autocare@gmail.com"
      );
    };

    const sendMessage = () => {
      if (!input.trim()) return;

      const userMsg = { sender: "user", text: input };
      const botMsg = { sender: "bot", text: getBotReply(input) };

      setMessages(prev => [...prev, userMsg, botMsg]);
      setInput("");
    };
    const chatRef = useRef(null);
  const botBtnRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        chatRef.current &&
        !chatRef.current.contains(e.target) &&
        botBtnRef.current &&
        !botBtnRef.current.contains(e.target)
      ) {
        setOpen1(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
    const [feedbacks, setFeedbacks] = useState([
      {
        name: "Rahul Verma",
        role: "Honda City Owner",
        feedback:
          "AutoCare Palwal provided outstanding service. My car feels brand new after the maintenance.",
        rating: 5,
      },
      {
        name: "Amit Sharma",
        role: "Hyundai Creta Owner",
        feedback:
          "Professional staff, transparent pricing and quick delivery. Best auto care in Palwal.",
        rating: 5,
      },
    ]);

    const [formData, setFormData] = useState({
      name: "",
      feedback: "",
      rating: 5,
    });

    const handleSubmit = (e) => {
      e.preventDefault();

      if (!formData.name || !formData.feedback) return;

      setFeedbacks([
        {
          name: formData.name,
          role: "Verified Customer",
          feedback: formData.feedback,
          rating: formData.rating,
        },
        ...feedbacks,
      ]);

      setFormData({ name: "", feedback: "", rating: 5 });
    };


    return (
      <>
  <Helmet>
    <title>
      Best Car Repair & Mechanic Service in Palwal | AutoCare
    </title>

    <meta
      name="description"
      content="AutoCare is an authorized car service center in Palwal providing car repair, servicing, mechanic support, home service, AC and brake repair."
    />

    <link
      rel="canonical"
      href="https://car-repair-mechanic-palwal.netlify.app/"
    />

    {/* Open Graph (Social Sharing) */}
    <meta property="og:title" content="Best Car Repair & Mechanic Service in Palwal | AutoCare" />
    <meta
      property="og:description"
      content="Trusted car repair and mechanic service in Palwal. Affordable, fast & professional auto care at your doorstep."
    />
    <meta
      property="og:url"
      content="https://car-repair-mechanic-palwal.netlify.app/"
    />
    <meta property="og:type" content="website" />
  </Helmet>

      {/* Hero Section */}
  <div className="bmwHero">
    <div className="heroOverlay"></div>

    <div className="heroContent">
      <span className="neoBadge">
        {heroContent[index].tagline}
      </span>
      <h1>Best car repair service in Palwal</h1>
      <h2 key={index} className="fadeText">
        {heroContent[index].heading}
      </h2>

      <p className="fadeText">
        {heroContent[index].desc}
      </p>

    <Link to="/contact"><button className="primaryBtn">
        {heroContent[index].btn}
      </button></Link>
    </div>
  </div>
  {/* 🤖 Bot Button */}
  <button
    ref={botBtnRef}
    className="botButton"
    onClick={() => setOpen1(prev => !prev)}
  >
    🤖
  </button>
  <a
    href="https://wa.me/919729299685"
    target="_blank"
    rel="noopener noreferrer"
    className="whatsappButton"
    aria-label="Chat with us on WhatsApp"
  >
    <img
      src="/brands/whatsapp.png"
      alt="Chat with us on WhatsApp"
      width="48"
      height="48"
      loading="lazy"
    />
  </a>

  {open1 && (
    <div ref={chatRef} className="chatBox">
      <div className="chatHeader">
        AutoCare Bot
        <span onClick={() => setOpen1(false)}>✖</span>
      </div>

      <div className="chatBody">
        {messages.map((msg, i) => (
          <div key={i} className={`msg ${msg.sender}`}>
            {msg.text}
          </div>
        ))}
      </div>

      <div className="chatInput">
        <input
          type="text"
          placeholder="Type your question..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && sendMessage()}
        />
        <button onClick={sendMessage}>Send</button>
      </div>
    </div>
  )}



  <div className="servicesSection">
      <div className="movingCar">
      <img src="/carServiceImages/car-removebg-preview.webp" alt="Moving Car" loading='lazy'/>
    </div>
    <h2 style={{color:'white', textAlign:'center'}}>We Offering</h2>

    <div className="servicesList">

      <div className="serviceCard">
        <Link to='/services/engine-oil-filter-change' style={{textDecoration:"none"}}>
        <div className="serviceIcon"><img src="/carServiceImages/oil.webp" alt="Oil Change" loading='lazy' style={{ width: '40px', height: '40px' }} /></div>
        <h3>Oil Change</h3>
        <p>Complete oil, lube & filter change to keep your engine running smoothly.</p>
        </Link>
      </div>

      <div className="serviceCard">
        <Link to='/services/brake-repair' style={{textDecoration:"none"}}>
        <div className="serviceIcon"><img src="/carServiceImages/brake.webp" alt="AutoCare Brake Service" style={{ width: '40px', height: '40px' }} /></div>
        <h3>Brake Service</h3>
        <p>Inspection and repair for safe and reliable braking performance.</p>
        </Link>
      </div>

      <div className="serviceCard">
        <Link to='/services/tyre' style={{textDecoration:"none"}}>
        <div className="serviceIcon"><img src="/carServiceImages/tire.webp" alt="Tire Rotation" loading='lazy' style={{ width: '40px', height: '40px' }} /></div>
        <h3>Tire Rotation</h3>
        <p>Proper tire rotation to improve grip and extend tire life.</p>
        </Link>
      </div>

      <div className="serviceCard">
        <Link to='/services/engine-repair' style={{textDecoration:"none"}}>
        <div className="serviceIcon"><img src="/carServiceImages/engine.webp" alt="Engine Diagnostics" loading='lazy' style={{ width: '40px', height: '40px' }} /></div>
        <h3>Engine Diagnostics</h3>
        <p>Advanced diagnostics to identify and fix engine issues.</p>
        </Link>
      </div>

      <div className="serviceCard">
        <Link to='/services/battery' style={{textDecoration:"none"}}>
        <div className="serviceIcon"><img src="/carServiceImages/battery.webp" alt="Best Battery & Tyre" loading='lazy' style={{ width: '40px', height: '40px' }} /></div>
        <h3>Battery & Tyre</h3>
        <p>Battery check and tyre service for smooth driving.</p>
        </Link>
      </div>

      <div className="serviceCard">
        <div className="serviceIcon"><img src="/carServiceImages/wash.webp" alt="Car Wash" loading='lazy' style={{ width: '40px', height: '40px' }} /></div>
        <h3>Car Wash</h3>
        <p>Professional exterior and interior car cleaning service.</p>
        
      </div>

      <div className="serviceCard">
      
        <div className="serviceIcon"><img src="/carServiceImages/ac.webp" alt="AC Repair" loading='lazy' style={{ width: '40px', height: '40px' }} /></div>
        <h3>AC Repair</h3>
        <p>AC gas refill and cooling system repair services.</p>
    
      </div>

      <div className="serviceCard">
        <Link to='/services/general-checkup' style={{textDecoration:"none"}}>
        <div className="serviceIcon"><img src="/carServiceImages/carservice.webp" alt="Best Car Servicing in Palwal" loading='lazy' style={{ width: '40px', height: '40px' }} /></div>
        <h3>Car Servicing</h3>
        <p>Complete car servicing to ensure peak performance.</p>
        </Link>
      </div>

      <div className="serviceCard">
        <Link to='/services' style={{textDecoration:"none"}}>
        <div className="serviceIcon"><img src="/carServiceImages/carservice.webp" alt="Best Car Servicing in Palwal" loading='lazy' style={{ width: '40px', height: '40px' }} /></div>
        <h3>All Services</h3>
        <p>Transmission, General Car Checkup, And more</p>
        </Link>
      </div>

    </div>
  </div>

        <div className='choose'>
          <h2 style={{ textAlign: 'center' }}>Why Choose Us in <span style={{ color: '#facc15', textAlign: 'center' }}>Palwal</span>?</h2>



  <h3>Best Car Service & Repair Near You</h3>
  <p>
    Looking for a reliable <strong>24/7 emergency car service in Palwal’s urban areas</strong> or searching for a 
    <span style={{ color: "#0f172a" }}> car service near me </span>
    without the usual hassle? At <strong>AutoCare</strong>, we provide professional and trusted 
    <span style={{ color: "#0f172a" }}> car service at home </span>
    so you don’t have to waste time visiting a workshop. Whether it’s routine maintenance, a quick tune-up, or a major repair, our expert mechanics ensure your car gets the care it deserves—right at your doorstep.
  </p>

  <p>
    With <strong>AutoCare</strong>, booking a 
    <span style={{ color: "#0f172a" }}> reliable car repair service in Palwal </span>
    is simple and convenient. You can easily schedule your service online or contact us directly—whichever suits you best. From start to finish, we keep the entire process transparent, easy to track, and completely stress-free.
  </p>

  <p>
    Our comprehensive 
    <span style={{ color: "#0f172a" }}> car maintenance services </span>
    include oil changes, tyre rotation, brake inspections, battery replacement, electrical repairs, and advanced diagnostics. Skip the long waiting times at repair shops—our on-demand 
    <span style={{ color: "#0f172a" }}> car service lets you choose the time and location </span>
    that works best for you.
  </p>

  <p>
    Quality is our top priority. At <strong>AutoCare</strong>, we use high-end tools and genuine spare parts to keep your vehicle running smoothly and safely. Facing an unexpected issue like a flat tyre or a dead battery? Our reliable roadside assistance ensures you’re never stranded. Whether you book online or call us, help for 
    <span style={{ color: "#0f172a" }}> car service and repairs </span>
    is always just a step away.
  </p>

  <p>
    We understand how important a well-maintained car is for daily commutes and long drives. That’s why we offer everything from AC servicing and engine checks to brake repairs and periodic maintenance packages. With <strong>AutoCare</strong>, getting professional 
    <span style={{ color: "#0f172a" }}> car service </span>
    has never been easier—quick booking, expert mechanics, and complete peace of mind.
  </p>

  <p>
    So, the next time you search for 
    <span style={{ color: "#0f172a" }}> car service near me in Palwal or Faridabad </span>,
    trust <strong>AutoCare</strong> to deliver reliable, affordable, and convenient car care at your doorstep. Keeping your car in top condition has never been this simple!
    <p><strong>Service available near me? Service provide in these Palwal areas </strong></p>
    <ul>

      <li style={{color:'black'}}>Rasulpur</li>
      <li style={{color:'black'}}>hathin</li>
      <li style={{color:'black'}}>Alhapur</li>
      <li style={{color:'black'}}>Agwaanpur</li>
    <li style={{color:'black'}}> Agra Chowk</li>
    <li style={{color:'black'}}> Anangpur</li>
    <li style={{color:'black'}}> Ashok Vihar</li>
    <li style={{color:'black'}}> CarServiceHome Raj Nagar</li>
    <li style={{color:'black'}}> Krishna Colony</li>
    <li style={{color:'black'}}> New Colony</li>
    <li style={{color:'black'}}> Minar Gate</li>
    <li style={{color:'black'}}> Huda Sector</li>
    <li style={{color:'black'}}> Railway Road</li>
    <li style={{color:'black'}}> Alhapur</li>
    <li style={{color:'black'}}> Kundli Manesar Palwal Expressway</li>
    <li style={{color:'black'}}> Bamnikhera</li>
    <li style={{color:'black'}}> Kushlipur</li>
    <li style={{color:'black'}}> Camp Market</li>
    </ul>
    <p>24/7 Service available at autocare palwal just one click away</p>
  </p>



      <h2 style={{color:'#0f172a'}}>Car Mechanic at Home – Quality Repairs with Ultimate Convenience</h2>
      <h3 style={{color:"#0f172a"}}>Why Choose Home Service?</h3>
  <p>
    Life is busy, and who has time to sit in a waiting room? Our car repair service brings skilled and certified mechanics right to your home. Whether it’s a quick oil change or a detailed inspection, you can sit back and relax while we take care of everything. Think of it as a stress-free day for your car—no traffic, no waiting, and no hassle.
  </p>
      
        </div>
        <section className="feedbackSection" style={{backgroundColor:'white', background:'none'}}>
        <div className="feedbackContainer">

          <h2>What Our Clients Say</h2>
          <p className="subtitle" style={{color:'black'}}>
            Trusted auto care & car repair services in Palwal — real reviews from real customers
          </p>

          {/* FEEDBACK GRID */}
          <div className="feedbackGrid">
            {feedbacks.map((item, index) => (
              <div className="feedbackCard" key={index}>
                <div className="rating">{"★".repeat(item.rating)}</div>
                <p className="feedbackText" style={{color:'black'}}>“{item.feedback}”</p>
                <div className="clientInfo">
                  <strong>{item.name}</strong>
                  <span>{item.role}</span>
                </div>
              </div>
            ))}
          </div>

          {/* ADD FEEDBACK FORM */}
          <div className="addFeedback">
            <h3>Add Your Feedback</h3>

            <form onSubmit={handleSubmit}>
              <input
                type="text"
                placeholder="Your Name"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
              />

              <textarea
                placeholder="Write your experience with AutoCare..."
                value={formData.feedback}
                onChange={(e) =>
                  setFormData({ ...formData, feedback: e.target.value })
                }
              ></textarea>

              <select
                value={formData.rating}
                onChange={(e) =>
                  setFormData({ ...formData, rating: Number(e.target.value) })
                }
              >
                <option value={5}>★★★★★ Excellent</option>
                <option value={4}>★★★★☆ Good</option>
                <option value={3}>★★★☆☆ Average</option>
              </select>

              <button type="submit">Submit Feedback</button>
            </form>

            <p className="note">
              * Feedback is temporary and for demo purposes only
            </p>
          </div>

        </div>
      </section>
        <div className="content">
    <div className="para-container">
      <p className="para">
        <span className="arrow">→</span>
        <strong>The Best of Both Worlds</strong><br />
        When you search for car service near me or best car mechanic in palwal, you want quality that doesn’t compromise on convenience. That’s exactly what we at AutoCare offer. Our car repair services at home combine the reliability of a garage visit with the comfort of your own space. Plus, our mechanics are trained to handle various issues, ensuring your ride gets the top-notch attention it deserves without the hassle.
      </p>
    </div>

    <div className="para-container">
      <p className="para">
        <span className="arrow">→</span>
        <strong>Easy Access with Our Apps</strong><br />
        With the AutoCare car repair app, booking a service has never been simpler. With just a few taps you can book our services in a whim. Not a techie Savvy person? No problem! Our car service website is user-friendly and designed to help you navigate your options effortlessly. We’ve got the tools to make car maintenance as easy as scrolling through your feed!
      </p>
    </div>

    <div className="para-container">
      <p className="para">
        <span className="arrow">→</span>
        <strong>Expertise Delivered to Your Doorstep</strong><br />
        Imagine having a car mechanic at home who’s not just knowledgeable but also friendly. Our team is not only skilled in car repair and maintenance services; we genuinely care about your vehicle’s well-being. We’ll break down what needs fixing, answer your questions, and even offer tips on keeping your car in shape. Think of us as your car’s personal pit crew!
      </p>
    </div>

    <div className="para-container">
      <p className="para">
        <span className="arrow">→</span>
        <strong>Safety and Trust</strong><br />
        Wondering if you can trust our car repair and maintenance services? Absolutely! Our mechanics come fully equipped with the right tools and expertise to tackle any job, big or small. We prioritize safety, making sure that you receive quality service without any surprises. So go ahead, let us handle the details while you enjoy peace of mind.
      </p>
    </div>

    {/* <!-- Optional: If you want to add more content for 2x2 grid --> */}
    <div className="para-container">
      <p className="para">
        <span className="arrow">→</span>
        <strong>More Than Just Repairs</strong><br />
        Not only do we fix issues, but we also help maintain your car’s health. From regular check-ups to emergency repairs, our car repair services cover all bases. Next time you think about car repair at home, remember that AutoCare is just a call away. So, whether it’s routine maintenance or unexpected trouble, we’re here to keep you moving.
      </p>
    </div>
  </div>
  <p style={{padding:'2rem'}}>In the fast-paced world we live in, choosing car service at home means getting your car the care it needs without missing a beat in your day. Whether through our car mechanic app or a quick phone call, we’re dedicated to making your car care experience as easy and stress-free as possible. Because who doesn’t want to keep cruising without the fuss?</p>
  <h2 style={{color:'navy',paddingLeft:'2rem'}}>Download Our Car Repair App – Book Services with a Click</h2>
  <p style={{padding:'2rem'}}>Ready to make car care super simple? With our car repair app, getting a service is as easy as scrolling through your feed. Whether you're at home or on the go, you can quickly book car repair services that suit your needs. No more wandering through endless pages of car service websites. Just install the AutoCare app from the play store, open the app, choose from various options like car service at home or a quick garage visit, and you’re all set. Feeling overwhelmed? Our intuitive interface makes it a breeze, so you can focus on what really matters to you!

  Got questions? Our car mechanic app is here to help! Want a friendly mechanic at home? You got it! Just hit up our app to connect with trusted professionals ready to tackle all your car repair and maintenance services. Whether it's a minor fix or a major overhaul, you'll find the perfect match. Plus, our app keeps you in the loop with real-time updates, so you always know what's happening with your ride. So why wait? Download our car repair app now and experience the convenience of car service near me, right at your fingertips!</p>
  <h2 style={{color:'navy',paddingLeft:'2rem'}}>Why Choose AutoCare Car Service and Repair?</h2>
  <p style={{padding:'2rem'}}>When it comes to keeping your car in great condition, AutoCare is your top choice. We understand you have options, but our unique combination of quality and convenience is unmatched. Picture this: your car needs some attention, and instead of driving around searching for "car service near me," you can just tap a button. Whether it’s car repair at home or detailed inspections, we’ve got everything you need and also making sure that you get the best value. Our skilled team is equipped to handle various vehicle makes and models, so you can trust us to care for your ride.

  Why settle for less when you can have more? AutoCare simplifies your experience with our car mechanic app, putting everything you need at your fingertips. Need to book car repair and maintenance services? No problem! Want a car mechanic at home? We’ve got you covered! Our easy booking process and dependable service mean you can forget about car worries. Make the smart choice—choose AutoCare for all your car repair services and enjoy the convenience that sets us apart from the rest!</p>

  <div className="process">
    <h2>Our Service Process</h2>
    <div className="cardContainer">
      <div className="card">
        <img src="/carServiceImages/appointment.webp" alt="Schedule Appointment with autocare" className="cardImage" />
        <h3>Schedule an Appointment</h3>
        <p>Book your car service online or via phone at your convenience.</p>
      </div>
      
      <div className="card">
        <img src="/carServiceImages/vehicle inspection.webp" alt="Vehicle Inspection" className="cardImage" />
        <h3>Vehicle Inspection</h3>
        <p>Our expert mechanics will perform a thorough inspection of your vehicle to identify any issues.</p>
      </div>
      
      <div className="card">
        <img src="/carServiceImages/Service Recommendation.webp" alt="AutoCare Service Recommendation" className="cardImage" />
        <h3>Service Recommendation</h3>
        <p>Based on the inspection, we will recommend the necessary services and provide a transparent cost estimate .</p>
      </div>
      
      <div className="card">
        <img src="/carServiceImages/Service Execution.webp" alt="Service Execution" className="cardImage" />
        <h3>Service Execution</h3>
        <p>Our skilled technicians will carry out the recommended services using genuine parts and advanced tools.</p>
      </div>
      
      <div className="card">
        <img src="/carServiceImages/Quality check.webp" alt="Quality Check" className="cardImage" />
        <h3>Quality Check</h3>
        <p>After servicing, we carry out a comprehensive quality check to ensure everything is in perfect condition. If the customer is not satisfied, we provide compensation.</p>
      </div>
      
      <div className="card">
        <img src="/carServiceImages/customer feedback.webp" alt="Customer Feedback" className="cardImage" />
        <h3>Customer Feedback</h3>
        <p>We respect your feedback and encourage you to share your experience to help us improve our services.</p>
      </div>
    </div>
  </div>
  <div className='FAQ'>
    <h2 style={{ fontWeight: 'bold', textAlign: 'center', fontSize: '40px' }}>
      Frequently Asked Questions – Car Service in <span style={{ color: '#facc15' }}>Palwal</span>
    </h2>

    <div className='qa'>

      <div className="question">
        <h3 onClick={() => handleClick(1)}>1. Do you provide car service at home in Palwal?</h3>
        {openQuestion === 1 && (
          <p>Yes, AutoCare provides doorstep car repair and servicing across Palwal and nearby areas.</p>
        )}
      </div>

      <div className="question">
        <h3 onClick={() => handleClick(2)}>2. How much does car servicing cost in Palwal?</h3>
        {openQuestion === 2 && (
          <p>Service cost depends on the car model and type of service. We provide transparent pricing before starting any work.</p>
        )}
      </div>

      <div className="question">
        <h3 onClick={() => handleClick(3)}>3. How long does a car service usually take?</h3>
        {openQuestion === 3 && (
          <p>Most car services are completed within 1–3 hours. Major repairs may take longer depending on the issue.</p>
        )}
      </div>

      <div className="question">
        <h3 onClick={() => handleClick(4)}>4. Do you use genuine spare parts?</h3>
        {openQuestion === 4 && (
          <p>Yes, we use only genuine or OEM-approved spare parts to ensure safety and long-term performance.</p>
        )}
      </div>

      <div className="question">
        <h3 onClick={() => handleClick(5)}>5. Is there any warranty on repairs?</h3>
        {openQuestion === 5 && (
          <p>Yes, we provide service warranty on selected repairs and parts. Details are shared before service.</p>
        )}
      </div>

      <div className="question">
        <h3 onClick={() => handleClick(6)}>6. How can I book a car service?</h3>
        {openQuestion === 6 && (
          <p>You can book a service online through our website or call us directly for instant booking.</p>
        )}
      </div>

    </div>
  </div>


      </>
    )
  }
